/* eslint-disable @typescript-eslint/naming-convention */
export enum TrailConfigurationOther {
  Angel = 'Angel',
  Animals = 'Animals',
  Culinary = 'Culinary',
  Guiding = 'Guiding',
  IndividualMobility = 'IndividualMobility',
  Mobility = 'Mobility',
  OffersOnly = 'OffersOnly',
  OnlineOnly = 'OnlineOnly',
  Package_Tour = 'Package_Tour',
  Passport_Required = 'Passport_Required',
  POI = 'POI',
  RequestsOnly = 'RequestsOnly'
}
